/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CookieFeedback } from '../../models/cookie-feedback';
import { CookieFeedbackApiRespModel } from '../../models/cookie-feedback-api-resp-model';

export interface ApiMasterCookieSaveCookieFeedbackPost$Params {
      body?: CookieFeedback
}

export function apiMasterCookieSaveCookieFeedbackPost(http: HttpClient, rootUrl: string, params?: ApiMasterCookieSaveCookieFeedbackPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CookieFeedbackApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterCookieSaveCookieFeedbackPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CookieFeedbackApiRespModel>;
    })
  );
}

apiMasterCookieSaveCookieFeedbackPost.PATH = '/api/Master/Cookie/SaveCookieFeedback';
